import { render, staticRenderFns } from "./VPanel.vue?vue&type=template&id=a253d236"
import script from "./VPanel.vue?vue&type=script&lang=js"
export * from "./VPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a253d236')) {
      api.createRecord('a253d236', component.options)
    } else {
      api.reload('a253d236', component.options)
    }
    module.hot.accept("./VPanel.vue?vue&type=template&id=a253d236", function () {
      api.rerender('a253d236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commons/VPanel.vue"
export default component.exports